import { render, staticRenderFns } from "./ContratoDespesaTipoForm.vue?vue&type=template&id=008e85c1&"
import script from "./ContratoDespesaTipoForm.vue?vue&type=script&lang=js&"
export * from "./ContratoDespesaTipoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports